import { css } from '@emotion/css';

const wrapper = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacings-4);
`;

const content = css`
  padding: 0 var(--dimensions-15);
  display: flex;
  flex-direction: column;
  gap: var(--spacings-4);
  align-items: center;

  @media (max-width: 728px) {
    padding: 0;

    .MuiButton-root {
      width: 100%;
    }
  }
`;

const errorContainer = css`
  border-radius: var(--radius-2);
  border: 1px solid var(--colors-neutral-300);
  background-color: var(--colors-neutral-150);
  color: var(--colors-error-900);
  padding: var(--spacings-8) var(--dimensions-5);
  display: flex;
  flex-direction: column;
  gap: var(--spacings-0);
  align-items: center;
  justify-content: center;
  width: 100%;

  button {
    text-decoration: underline;
  }
`;

const creatingAccountStyles = {
  content,
  wrapper,
  errorContainer,
};

export default creatingAccountStyles;
